import { Translation } from "../../hooks/useTranslations";
import { UserLight } from "./users";

export type Project = {
  id: string;
  name: string;
  language: string;
  status: string;
  description?: string;
  address?: string;
  city?: string;
  country?: string;
  coordinates?: string;
  company?: string;
  contactPerson?: string;
  author: UserLight;
  createdAt: string;
  editor: UserLight;
  modifiedAt: string;
  canEdit: boolean;
};

export type SearchAdminProject = {
  id: string;
  name: string;
  address?: string;
  city?: string;
  country?: string;
  author: UserLight;
  createdAt: string;
  editor: UserLight;
  modifiedAt: string;
  status: string;
};

export type SearchProject = {
  id: string;
  name: string;
  address?: string;
  city?: string;
  country?: string;
  author: UserLight;
  modifiedAt: string;
  language: string;
  status: string;
  canEdit: boolean;
};

export type InsertProjectBody = {
  name: string;
  description?: string;
  language: string;
};

export type UpdateProjectBody = InsertProjectBody & {
  status: string;
  address?: string;
  city?: string;
  country?: string;
  coordinates?: string;
  company?: string;
  contactPerson?: string;
};

export type ProjectStatusColor = "success" | "info" | "warning" | "error" | "grey";

export type ProjectStatus = {
  value: string;
  display: string;
  color: ProjectStatusColor;
};

export const getProjectStatusValues = (translations: Translation): ProjectStatus[] => [
  { value: "offer", display: translations.common.offer, color: "grey" },
  { value: "confirmed", display: translations.common.confirmed, color: "info" },
  { value: "toBeInstalled", display: translations.common.toBeInstalled, color: "warning" },
  { value: "installed", display: translations.common.installed, color: "success" },
  { value: "toInspect", display: translations.common.toInspect, color: "error" },
  { value: "archived", display: translations.common.archived, color: "grey" },
];
